// extracted by mini-css-extract-plugin
module.exports = {"uiBreadcrumb":"breadcrumb_uiBreadcrumb__ozHDK"};